import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Pane } from '@folio/stripes/components';
var GeneralSettings = function () { return (React.createElement(Pane, { defaultWidth: "fill", fluidContentWidth: true, paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.settings.general" }) },
    React.createElement("div", { "data-test-application-settings-general-message": true },
        React.createElement(FormattedMessage, { id: "ui-czna-users.settings.general.description" })))); };
export default GeneralSettings;
